import React from "react";
import Helmet from 'react-helmet';
import Template from "./template";

export default class AccessibilityStatement extends React.Component {
  render() {
    const title = 'Accessibility Statement';
    return (
      <Template title="Accessibility Statement">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title}/>
          <meta
            name="description"
            content={`Learn more about our accessibility statement. Sotheby’s International Realty sells exquisite homes in premier locations across the US.`}/>
        </Helmet>

        <div>
          <h2>Accessibility Assistance</h2>
          
          <p>
              If you need assistance accessing - or have any other concerns about the accessibility of - our websites and mobile applications, please contact one of our representatives at <a href="mailto:accessibility@realogy.com">accessibility@realogy.com</a> or <a href="tel:877-947-3313">877-947-3313</a> and we will work with you to provide the information you need. For those who are deaf or hard of hearing, or who do not use voice channels to communicate, please contact us via email or via 711 or other relay services.
          </p>
          <br />
          <h2>Goal of Accessibility for All</h2>
          
          <p>
              We desire to provide a positive experience to all stakeholders, and we aim to promote accessibility and inclusion. Our goal is to enable our users to successfully gather information through our websites and mobile applications.
          </p>
          <br />
          <p> Whether you are using assistive technologies like a screen reader, a magnifier, voice recognition software, or captions for videos, our goal is to make your use of our technology a successful and enjoyable experience.</p>
          <br />
          <h2>Actions</h2>
          
          <p>
              We are actively taking a variety of steps and devoting resources to further enhance the accessibility of our websites, mobile applications, and other technology platforms, including using the W3C WAI Web Content Accessibility Guidelines (WCAG) 2.1 Level AA success criteria.
          </p>
          <br />
          <h2>Ongoing Effort</h2>
          
          <p>
              Although we are proud of the efforts that we have completed and that are in-progress, we view accessibility as an ongoing effort.
          </p>
          <br />
          <h2>Feedback</h2>
          
          <p>
              Please contact us at <a href="mailto:accessibility@realogy.com">accessibility@realogy.com</a> or <a href="tel:877-947-3313">877-947-3313</a> if you have any feedback or suggestions as to how we could improve the accessibility of our websites, mobile applications, and other technology platforms.
          </p>
          <br />
        </div>
      </Template>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/about-us/accessibility-statement.js